module.exports = __webpack_public_path__ + "img/zhencha.4c606bb7.jpg";